import React, {useEffect, useState} from 'react'
import {Table, Card} from 'antd'
import {Link} from 'react-router-dom'
import {getBrandList} from './service'

const List = () => {
  const [brandList, setBrandList] = useState([])

  useEffect(() => {
    getBrandListFn()
  }, [])

  const getBrandListFn = async () => {
    const res = await getBrandList()
    if (res) {
      setBrandList(res)
    }
  }

  const columns = [
    {
      title: '社群名称',
      dataIndex: 'brand_name'
    },
    {
      title: '操作',
      dataIndex: 'operation',
      width: 120,
      render: (text, record, index) => {
        return (
          <Link to={`editbrandwx/${record.brand_id}?brandname=${record.brand_name}`}>编辑</Link>
        )
      }
    }
  ]

  return (
    <Card title='社群列表' bordered={false}>
      <Table
        style={{width: '800px'}}
        rowKey="id"
        dataSource={brandList}
        columns={columns}
        bordered={true}
        pagination={false}
      />
    </Card>

  )
}

export default List


// WEBPACK FOOTER //
// ./src/pages/brandwx/list.js